<template>
  <div class="error-screen">
    <v-container>
      <v-alert class="error-message" type="error" text>
        <p>Die Inhalte konnten nicht geladen werden.</p>
        <router-link to="/">Zurück zur Startseite</router-link>
      </v-alert>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ErrorScreen"
};
</script>
